@if (userName()) {
  <div class="user-menu">
    <button
      type="button"
      class="user-profile-card"
      [attr.aria-expanded]="expanded()"
      [attr.aria-label]="userName()"
      aria-haspopup="true"
      (click)="toggle()">
      <span class="user-avatar">{{ initials() }}</span>
      <mat-icon class="user-chevron" [class.rotate-180]="expanded()">expand_more</mat-icon>
    </button>
    @if (expanded()) {
      <div class="user-menu-panel">
        <div class="user-menu-meta">
          <div class="user-name">{{ userName() }}</div>
          @if (userEmail()) {
            <div class="user-email">{{ userEmail() }}</div>
          }
          <div class="user-role">{{ rolesLine() }}</div>
        </div>
        <div class="user-menu-divider"></div>
        <a
          class="menu-action"
          href="mailto:attorneyrelations@legalresources.com"
          title="Email Attorney Relations"
          (click)="expanded.set(false)">
          <mat-icon>help</mat-icon>
          <span>Need help</span>
        </a>
        <div class="user-menu-divider"></div>
        <button type="button" class="logout-button" (click)="logout()">
          <mat-icon>logout</mat-icon>
          <span>Logout</span>
        </button>
      </div>
    }
  </div>
}
